import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';
import { L10nSchema } from 'angular-l10n';
import { L10nService } from '@nano/core/l10n';

@Component({
  selector: 'app-lang',
  templateUrl: 'lang.component.html',
  styleUrls: ['lang.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class LangComponent {
  @Input() icon = 'drop';
  @Input() iconOnHover = 'droph';

  readonly schemas$: Observable<L10nSchema[]> = this.l10nService.schemas$;
  readonly schema$: Observable<L10nSchema> = this.l10nService.schema$;

  popoverVisible: boolean;

  constructor(private l10nService: L10nService) {}

  onPopoverVisibleChange(popoverVisible: boolean): void {
    this.popoverVisible = popoverVisible;
  }

  setSchema(schema: L10nSchema): void {
    this.popoverVisible = false;
    this.l10nService.setSchema(schema).subscribe();
  }
}
